import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GuestBrandedDefaultColors } from 'common/compounds/GuestBrandedTheme/constants';

// This component is for Guest side usage (should not be used in Host side pages). It's a styled component to look like
// Carina components.
// NOTE: This component could be further improved by using styled-component or Radix-ui
const getBrandColors = () => ({
    filled: {
        background: `var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`,
        backgroundHover: `var(--guest-branded-actionHover, ${GuestBrandedDefaultColors.actionHover})`,
        backgroundActive: `var(--guest-branded-actionActive, ${GuestBrandedDefaultColors.actionActive})`,
        color: `var(--guest-branded-actionText, ${GuestBrandedDefaultColors.actionText})`,
        border: '1px solid transparent',
    },
    lined: {
        background: 'transparent',
        backgroundHover: `var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`,
        backgroundActive: `var(--guest-branded-actionActive, ${GuestBrandedDefaultColors.actionActive})`,
        color: `var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`,
        colorHover: `var(--guest-branded-actionText, ${GuestBrandedDefaultColors.actionText})`,
        colorActive: `var(--guest-branded-actionText, ${GuestBrandedDefaultColors.actionText})`,
        border: `1px solid var(--guest-branded-action, ${GuestBrandedDefaultColors.action})`,
    },
});

const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    borderRadius: '10px',
    minWidth: '96px',
    minHeight: '40px',
    padding: '0 24px',
    fontSize: '1rem',
    fontFamily: 'inherit',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease',
    userSelect: 'none',
};

const GuestBrandedButton = ({ text, appearance = 'filled', onClick, disabled = false }) => {
    const brandColors = getBrandColors();
    const colors = brandColors[appearance];

    const [hover, setHover] = useState(false);
    const [active, setActive] = useState(false);

    const style = {
        ...baseStyle,
        backgroundColor: active ? colors.backgroundActive : hover ? colors.backgroundHover : colors.background,
        color: active ? colors.colorActive || colors.color : hover ? colors.colorHover || colors.color : colors.color,
        border: colors.border,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
    };

    return (
        <button
            type="button"
            onClick={!disabled ? onClick : undefined}
            style={style}
            disabled={disabled}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => {
                setHover(false);
                setActive(false);
            }}
            onMouseDown={() => setActive(true)}
            onMouseUp={() => setActive(false)}
        >
            {text}
        </button>
    );
};

GuestBrandedButton.propTypes = {
    text: PropTypes.string.isRequired,
    appearance: PropTypes.oneOf(['filled', 'lined']),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export default GuestBrandedButton;
